import R_Define from '../util/R_Define';

const init = () => {
    return class R_Tick {
        static tickSwal(world) {
            world.children
                .sort((a, b) => R_Define.ORDER.indexOf(a.type) - R_Define.ORDER.indexOf(b.type));
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_Tick.js